import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import { Bar, Line } from "react-chartjs-2";
import { cn } from "../../../../utils/useFunctions";
import {
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_MEDIUM_BLUE_12,
  STYLE_PDF_TEXT_NORMAL_10,
} from "../../styles/pdf.style";
import { useEffect, useMemo, useState } from "react";
import { useUserStore } from "../../../../_store/userStore";
import api from "../../../../api/api.main";
import numeral from "numeral";
import { SumSaving } from "../../../../functions/Balance/sumSaving";
import { SumVariableExpense } from "../../../../functions/Balance/sumVariableExpense";
import { useBalanceStore } from "../../../../_store/balanceStore";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const AnalysisTableOne = () => {
  const userData = useUserStore((state) => state.userData);
  const balanceData = useBalanceStore((state) => state?.balanceData);

  const [allData, setAllData] = useState([]);
  const THisYear = new Date().getFullYear() + 543;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: dataStorage } = await api.get(
          `/storages/profileAll/${userData?._id}`
        );

        if (dataStorage?.storages?.length < 4) {
          for (let index = dataStorage?.storages?.length; index < 4; index++) {
            dataStorage?.storages.push({});
          }
        }

        setAllData(dataStorage?.storages);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [userData?._id]);

  const addExpensesInvest = (balanceData) => {
    return balanceData?.expenses_invest_saving_list
      ? balanceData.expenses_invest_saving_list
      : [];
  };
  const netCashFlow = (balanceData) => {
    return (
      balanceData?.sum_salary_peryear +
      balanceData?.sum_interest_peryear +
      balanceData?.sum_other_income -
      (balanceData?.sum_expenses_fixed +
        SumSaving(
          balanceData?.expenses_invest_saving_list
            ? balanceData.expenses_invest_saving_list
            : []
        ) +
        SumVariableExpense(
          balanceData?.expenses_variable_list
            ? balanceData.expenses_variable_list
            : []
        ))
    );
  };

  const years = allData?.map((item, index) => {
    if (!item?.createdAt) {
      // return new Date().getFullYear() + 543 ;
      return null;
    }
    const d = new Date(item.createdAt);
    // Convert to Buddhist Era (BE)
    return d.getFullYear() + 543;
  });

  // Bar chart data
  const barChartData = {
    labels: allData?.map((item, index) => {
      return years[index] || THisYear + index;
    }),
    datasets: [
      {
        label: "กระแสเงินสดสุทธิ",
        data: [
          Number(allData[0]?.balanceData?.sum_salary_peryear || 0) +
            Number(allData[0]?.balanceData?.sum_interest_peryear || 0) +
            Number(allData[0]?.balanceData?.sum_other_income || 0) -
            (Number(allData[0]?.balanceData?.sum_expenses_fixed || 0) +
              Number(allData[0]?.balanceData?.sum_expenses_variable || 0) +
              Number(allData[0]?.balanceData?.sum_property_invest || 0)),
          Number(allData[1]?.balanceData?.sum_salary_peryear || 0) +
            Number(allData[1]?.balanceData?.sum_interest_peryear || 0) +
            Number(allData[1]?.balanceData?.sum_other_income || 0) -
            (Number(allData[1]?.balanceData?.sum_expenses_fixed || 0) +
              Number(allData[1]?.balanceData?.sum_expenses_variable || 0) +
              Number(allData[1]?.balanceData?.sum_property_invest || 0)),
          Number(allData[2]?.balanceData?.sum_salary_peryear || 0) +
            Number(allData[2]?.balanceData?.sum_interest_peryear || 0) +
            Number(allData[2]?.balanceData?.sum_other_income || 0) -
            (Number(allData[2]?.balanceData?.sum_expenses_fixed || 0) +
              Number(allData[2]?.balanceData?.sum_expenses_variable || 0) +
              Number(allData[2]?.balanceData?.sum_property_invest || 0)),
          Number(allData[3]?.balanceData?.sum_salary_peryear || 0) +
            Number(allData[3]?.balanceData?.sum_interest_peryear || 0) +
            Number(allData[3]?.balanceData?.sum_other_income || 0) -
            (Number(allData[3]?.balanceData?.sum_expenses_fixed || 0) +
              Number(allData[3]?.balanceData?.sum_expenses_variable || 0) +
              Number(allData[3]?.balanceData?.sum_property_invest || 0)), // Will be calculated
        ],
        backgroundColor: "#0A3D62",
      },
      {
        label: "รายจ่ายรวม",
        data: [
          Number(allData[0]?.balanceData?.sum_expenses_fixed || 0) +
            Number(allData[0]?.balanceData?.sum_expenses_variable || 0) +
            Number(allData[0]?.balanceData?.sum_expenses_invest_saving || 0),
          Number(allData[1]?.balanceData?.sum_expenses_fixed || 0) +
            Number(allData[1]?.balanceData?.sum_expenses_variable || 0) +
            Number(allData[1]?.balanceData?.sum_expenses_invest_saving || 0),
          Number(allData[2]?.balanceData?.sum_expenses_fixed || 0) +
            Number(allData[2]?.balanceData?.sum_expenses_variable || 0) +
            Number(allData[2]?.balanceData?.sum_expenses_invest_saving || 0),
          Number(allData[3]?.balanceData?.sum_expenses_fixed || 0) +
            Number(allData[3]?.balanceData?.sum_expenses_variable || 0) +
            Number(allData[3]?.balanceData?.sum_expenses_invest_saving || 0),
        ],
        backgroundColor: "#7FB3D5",
      },
      {
        label: "รายรับรวม",
        data: [
          // 111,222,333,444
          Number(allData[0]?.balanceData?.sum_salary_peryear || 0) +
            Number(allData[0]?.balanceData?.sum_interest_peryear || 0) +
            Number(allData[0]?.balanceData?.sum_other_income || 0),
          Number(allData[1]?.balanceData?.sum_salary_peryear || 0) +
            Number(allData[1]?.balanceData?.sum_interest_peryear || 0) +
            Number(allData[1]?.balanceData?.sum_other_income || 0),
          Number(allData[2]?.balanceData?.sum_salary_peryear || 0) +
            Number(allData[2]?.balanceData?.sum_interest_peryear || 0) +
            Number(allData[2]?.balanceData?.sum_other_income || 0),

          Number(allData[3]?.balanceData?.sum_salary_peryear || 0) +
            Number(allData[3]?.balanceData?.sum_interest_peryear || 0) +
            Number(allData[3]?.balanceData?.sum_other_income || 0),
        ], // Will be calculated
        backgroundColor: "#AED6F1",
      },
    ],
  };
  // console.log("barChartData 7777",barChartData)
  // console.log(
  //   Number(allData[1]?.balanceData?.sum_salary_peryear || 0) +
  //     Number(allData[1]?.balanceData?.sum_interest_peryear || 0) +
  //     Number(allData[1]?.balanceData?.sum_other_income || 0)
  // );

  // barChartData.datasets[2].data = barChartData.datasets[0].data?.map(
  //   (netCash, i) => {
  //     return netCash + barChartData.datasets[1].data[i];
  //   }
  // );

  // Line chart data
  const lineChartData = {
    labels: years,
    datasets: [
      {
        label: "กระแสเงินสดสุทธิ",
        data: [
          Number(allData[0]?.balanceData?.sum_salary_peryear || 0) +
            Number(allData[0]?.balanceData?.sum_interest_peryear || 0) +
            Number(allData[0]?.balanceData?.sum_other_income || 0) -
            (Number(allData[0]?.balanceData?.sum_expenses_fixed || 0) +
              Number(allData[0]?.balanceData?.sum_expenses_variable || 0) +
              (netCashFlow(allData[0]?.balanceData) +
                SumSaving(addExpensesInvest(allData[0]?.balanceData)) <
              0
                ? 0
                : netCashFlow(allData[0]?.balanceData) +
                  SumSaving(addExpensesInvest(allData[0]?.balanceData)))),
          Number(allData[1]?.balanceData?.sum_salary_peryear || 0) +
            Number(allData[1]?.balanceData?.sum_interest_peryear || 0) +
            Number(allData[1]?.balanceData?.sum_other_income || 0) -
            (Number(allData[1]?.balanceData?.sum_expenses_fixed || 0) +
              Number(allData[1]?.balanceData?.sum_expenses_variable || 0) +
              (netCashFlow(allData[1]?.balanceData) +
                SumSaving(addExpensesInvest(allData[1]?.balanceData)) <
              0
                ? 0
                : netCashFlow(allData[1]?.balanceData) +
                  SumSaving(addExpensesInvest(allData[1]?.balanceData)))),
          Number(allData[2]?.balanceData?.sum_salary_peryear || 0) +
            Number(allData[2]?.balanceData?.sum_interest_peryear || 0) +
            Number(allData[2]?.balanceData?.sum_other_income || 0) -
            (Number(allData[2]?.balanceData?.sum_expenses_fixed || 0) +
              Number(allData[2]?.balanceData?.sum_expenses_variable || 0) +
              (netCashFlow(allData[2]?.balanceData) +
                SumSaving(addExpensesInvest(allData[2]?.balanceData)) <
              0
                ? 0
                : netCashFlow(allData[2]?.balanceData) +
                  SumSaving(addExpensesInvest(allData[2]?.balanceData)))),
          Number(allData[3]?.balanceData?.sum_salary_peryear || 0) +
            Number(allData[3]?.balanceData?.sum_interest_peryear || 0) +
            Number(allData[3]?.balanceData?.sum_other_income || 0) -
            (Number(allData[3]?.balanceData?.sum_expenses_fixed || 0) +
              Number(allData[3]?.balanceData?.sum_expenses_variable || 0) +
              (netCashFlow(allData[3]?.balanceData) +
                SumSaving(addExpensesInvest(allData[3]?.balanceData)) <
              0
                ? 0
                : netCashFlow(allData[3]?.balanceData) +
                  SumSaving(addExpensesInvest(allData[3]?.balanceData)))), // Will be calculated
        ],
        borderColor: "#0A3D62",
        backgroundColor: "#0A3D62",
        borderWidth: 2,
        pointRadius: 2,
        pointHoverRadius: 8,
        tension: 0.1,
      },
      {
        label: "รายจ่ายรวม",
        data: [
          Number(allData[0]?.balanceData?.sum_expenses_fixed || 0) +
            Number(allData[0]?.balanceData?.sum_expenses_variable || 0) +
            Number(allData[0]?.balanceData?.sum_expenses_invest_saving || 0),
          Number(allData[1]?.balanceData?.sum_expenses_fixed || 0) +
            Number(allData[1]?.balanceData?.sum_expenses_variable || 0) +
            Number(allData[1]?.balanceData?.sum_expenses_invest_saving || 0),
          Number(allData[2]?.balanceData?.sum_expenses_fixed || 0) +
            Number(allData[2]?.balanceData?.sum_expenses_variable || 0) +
            Number(allData[2]?.balanceData?.sum_expenses_invest_saving || 0),
          Number(allData[3]?.balanceData?.sum_expenses_fixed || 0) +
            Number(allData[3]?.balanceData?.sum_expenses_variable || 0) +
            Number(allData[3]?.balanceData?.sum_expenses_invest_saving || 0),
        ],
        borderColor: "#7FB3D5",
        backgroundColor: "#7FB3D5",
        borderWidth: 2,
        pointRadius: 2,
        pointHoverRadius: 8,
        tension: 0.1,
      },
      {
        label: "รายรับรวม",
        data: [
          Number(allData[0]?.balanceData?.sum_salary_peryear || 0) +
            Number(allData[0]?.balanceData?.sum_interest_peryear || 0) +
            Number(allData[0]?.balanceData?.sum_other_income || 0),
          Number(allData[1]?.balanceData?.sum_salary_peryear || 0) +
            Number(allData[1]?.balanceData?.sum_interest_peryear || 0) +
            Number(allData[1]?.balanceData?.sum_other_income || 0),
          Number(allData[2]?.balanceData?.sum_salary_peryear || 0) +
            Number(allData[2]?.balanceData?.sum_interest_peryear || 0) +
            Number(allData[2]?.balanceData?.sum_other_income || 0),
          Number(allData[3]?.balanceData?.sum_salary_peryear || 0) +
            Number(allData[3]?.balanceData?.sum_interest_peryear || 0) +
            Number(allData[3]?.balanceData?.sum_other_income || 0),
        ],
        borderColor: "#AED6F1",
        backgroundColor: "#AED6F1",
        borderWidth: 2,
        pointRadius: 2,
        pointHoverRadius: 8,
        tension: 0.1,
      },
    ],
  };

  // Bar chart options
  const barChartOptions = {
    devicePixelRatio: 5,
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: {
          display: false,
        },
        barThickness: 10, // Adjust bar thickness
        categoryPercentage: 0.1, // Adjust spacing between bar groups
        barPercentage: 0.1, // Adjust spacing between individual bars
        ticks: {
          font: {
            size: 8, // ← X‐axis label size
            weight: "400", // optional
          },
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => {
            if (value === 0) return "0";
            return `${Number(value) / 1000000}M`;
          },
          font: {
            size: 8,
            weight: "400",
          },
          stepSize: 10000000,
        },
        grid: {
          color: "#E5E7EB",
        },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => {
            let label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += new Intl.NumberFormat("th-TH", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(context.parsed.y);
            }
            return label;
          },
        },
      },
      legend: {
        display: false,
        position: "bottom",
        labels: {
          display: false,
          usePointStyle: false, // ← turn OFF point styles so you get rectangles
          boxWidth: 50, // ← how wide the little swatch is
          boxHeight: 12, // ← how tall the little swatch is
          padding: 20, // ← space between items
          font: {
            size: 6, // ← set your desired font size (px)
            weight: "500", // optional: 'normal', 'bold', or numeric
          },
        },
      },
    },
  };

  // Line chart options
  const lineChartOptions = {
    devicePixelRatio: 5,
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        ticks: {
          callback: (value) => {
            if (value === 0) return "0";
            return `${Number(value) / 1000000}M`;
          },
          font: {
            size: 8,
            weight: "400",
          },
          stepSize: 10000000,
          font: {
            size: 8,
            weight: "400",
          },
        },
        grid: {
          color: "#E5E7EB",
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 8, // ← X‐axis label size
            weight: "400", // optional
          },
        },
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        display: false,
        labels: {
          usePointStyle: false,
          padding: 20,
        },
      },
    },
  };

  // Utility function to convert ISO date to 'D/M/BE' format
  function formatToThaiDate(isoString) {
    if (!isoString) return "";
    const d = new Date(isoString);
    const day = d.getDate();
    const month = d.getMonth() + 1;
    const year = d.getFullYear() + 543;
    return `${day}/${month}/${year}`;
  }

  // console.log("THisYear", THisYear);
  // console.log("allData", allData);

  return (
    <div className="bg-blue-50 rounded-xl p-[15px] mt-5 ">
      {/* Header */}
      <div className="bg-white rounded-xl py-[10px] px-[5px] shadow-sm">
        <div className="flex items-center gap-[5px]">
          <img
            src="images/personal-report.png"
            alt="Description"
            width={14}
            height={14}
          />
          <h1 className={cn(STYLE_PDF_TEXT_MEDIUM_11, "font-bold")}>
            ตารางสรุปการวิเคราะห์ทางการเงิน
          </h1>
        </div>
      </div>

      {/* Section Title */}
      <div>
        <h2 className={cn(STYLE_PDF_TEXT_NORMAL_10, "font-bold my-[10px]")}>
          1. รายรับ รายจ่าย กระแสเงินสดสุทธิ
        </h2>
      </div>
      <div className="bg-white rounded-[14px]">
        {/* Table */}
        <div className="overflow-x-auto mb-6">
          <table className="w-full h-fit rounded-t-[10px]    ">
            <thead className="rounded-t-[10px]  ">
              <tr className="">
                <th
                  className={cn(
                    STYLE_PDF_TEXT_MEDIUM_BLUE_12,
                    " font-semibold text-left  h-full w-fit p-0 "
                  )}
                >
                  <div className="pl-[5px] pb- h-full w-full bg-gray-100 rounded-tl-[10px] border-l-0 border-r-[0.5px] border-t-[0.5px] border-gray-200 ">
                    รายละเอียด
                  </div>
                </th>
                {allData?.map((item, index) => (
                  <th
                    key={index}
                    className={cn(
                      STYLE_PDF_TEXT_MEDIUM_BLUE_12,
                      ` font-semibold text-center text-[10px] p-0 h-full`
                    )}
                  >
                    <div
                      className={cn(
                        `${STYLE_PDF_TEXT_MEDIUM_BLUE_12} border border-l-0 border-b-0`,
                        ` font-semibold text-center text-[10px] h-full w-full bg-gray-100 border-gray-200 ${
                          index === 3
                            ? "rounded-tr-[10px] border-r-[0.5px]"
                            : ""
                        }`
                      )}
                    >
                      {years[index] || THisYear + index}
                      <div
                        className={cn(
                          STYLE_PDF_TEXT_MEDIUM_BLUE_12,
                          "text-[8px]"
                        )}
                      >
                        {years[index] && (
                          <span>
                            แก้ไขข้อมูลล่าสุด{" "}
                            {formatToThaiDate(item?.updatedAt)}
                          </span>
                        )}
                      </div>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {/* Category Header - งบดุล */}
              <tr className="border-b-[1px] border-b-[#18488A]">
                <td className="p-0 bg-white ">
                  <div className="flex items-center pl-[5px] py-[3px] border-l-0 border-t-0 border-[0.5px]  border-gray-200 border-b-0 ">
                    {/* handholdmoneyandhouse.png */}
                    <img
                      src="images/handholdmoneyandhouse.png"
                      alt="Description"
                      width={14}
                      height={14}
                      className="mr-[5px]"
                    />
                    <span
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_12,
                        "font-semibold text-[9px] text-black"
                      )}
                    >
                      งบดุล
                    </span>
                  </div>
                </td>
                <td className=" p-0 ">
                  <div className="!w-full !h-full border-l-0 border-t-0 border-[0.5px]  border-gray-200 border-b-0 "></div>
                </td>
                <td className=" p-0 ">
                  <div className="!w-full !h-full border-l-0 border-t-0 border-[0.5px]  border-gray-200 border-b-0 "></div>
                </td>
                <td className=" p-0">
                  <div className="!w-full !h-full border-l-0 border-t-0 border-[0.5px] border-r-[0.5px] border-gray-200 border-b-0 "></div>
                </td>
              </tr>

              {/* รายรับ Category */}
              <tr className="h-fit w-fit">
                <td className=" text-[8px] p-0 text-[#00A9A0] font-medium ">
                  <div className=" w-full h-full p-[1px] pl-[5px] border-l-0 border-t-0 border-[0.5px]">
                    รายรับ
                  </div>
                </td>
                {allData?.map((item, index) => (
                  <td
                    key={index}
                    className=" text-[8px] p-0 text-center text-[#18488A] font-medium"
                  >
                    <div
                      className={cn(
                        " w-full h-full p-[1px] pl-[5px] border-r-[0.5px] border-b-[0.5px]"
                        // { "border-r-0": index === 3 }
                      )}
                    >
                      {item?.balanceData?.sum_salary_peryear +
                      item?.balanceData?.sum_interest_peryear +
                      item?.balanceData?.sum_other_income
                        ? numeral(
                            item?.balanceData?.sum_salary_peryear +
                              item?.balanceData?.sum_interest_peryear +
                              item?.balanceData?.sum_other_income
                          ).format("0,0")
                        : "-"}
                    </div>
                  </td>
                ))}
              </tr>

              {/* รายรับ Subcategories */}
              {[
                { name: "เงินเดือน", value: "sum_salary_peryear" },
                { name: "ดอกเบี้ย", value: "sum_interest_peryear" },
                { name: "รายรับอื่น ๆ", value: "sum_other_income" },
              ]?.map((itemA, index) => (
                <tr key={index} className="h-fit w-fit">
                  <td className=" font-medium text-[8px] p-0 text-[#18488A]">
                    <div className=" w-full h-full p-[1px] pl-[10px] border-l-0 border-t-0 border-[0.5px]">
                      {itemA.name}
                    </div>
                  </td>
                  {allData?.map((item, idx) => (
                    <td
                      key={idx}
                      className=" font-normal text-[7px] p-[0px] text-[#18488A] text-center"
                    >
                      <div
                        className={cn(
                          " w-full h-full p-[1px] pl-[5px] border-r-[0.5px] border-b-[0.5px]"
                          // { "border-r-0": idx === 3 }
                        )}
                      >
                        {/* {itemA.value} */}
                        {item?.balanceData?.[itemA.value]
                          ? numeral(item?.balanceData[itemA.value]).format(
                              "0,0"
                            )
                          : "-"}
                      </div>
                    </td>
                  ))}
                </tr>
              ))}

              {/* รายจ่าย Category */}
              <tr className="h-fit w-fit">
                <td className=" text-[8px] p-[0px] text-[#00A9A0] font-medium">
                  <div className=" w-full h-full p-[1px] pl-[5px] border-l-0 border-t-0 border-[0.5px]">
                    รายจ่าย
                  </div>
                </td>
                {allData?.map((item, index) => (
                  <td
                    key={index}
                    className=" text-[8px] p-[0] text-center text-[#18488A] font-medium"
                  >
                    <div
                      className={cn(
                        " w-full h-full p-[1px] pl-[5px] border-r-[0.5px] border-b-[0.5px]"
                        // { "border-r-0": index === 3 }
                      )}
                    >
                      {Number(item?.balanceData?.sum_expenses_fixed || 0) +
                        Number(item?.balanceData?.sum_expenses_variable || 0) +
                        (netCashFlow(item?.balanceData) +
                          SumSaving([...addExpensesInvest(item?.balanceData)]) <
                        0
                          ? 0
                          : netCashFlow(item?.balanceData) +
                            SumSaving([
                              ...addExpensesInvest(item?.balanceData),
                            ])) && item?.balanceData
                        ? // Number(item?.balanceData?.sum_expenses_invest_saving || 0)
                          numeral(
                            Number(item?.balanceData?.sum_expenses_fixed || 0) +
                              Number(
                                item?.balanceData?.sum_expenses_variable || 0
                              ) +
                              (netCashFlow(item?.balanceData) +
                                SumSaving([
                                  ...addExpensesInvest(item?.balanceData),
                                ]) <
                              0
                                ? 0
                                : netCashFlow(item?.balanceData) +
                                  SumSaving([
                                    ...addExpensesInvest(item?.balanceData),
                                  ]))
                            // Number(
                            //   item?.balanceData?.sum_expenses_invest_saving ||
                            //     0
                            // )
                          ).format("0,0")
                        : "-"}
                    </div>
                  </td>
                ))}
              </tr>

              {/* รายจ่าย Subcategories */}
              {[
                { name: "รายจ่ายคงที่", value: "sum_expenses_fixed" },
                { name: "รายจ่ายผันแปร", value: "sum_expenses_variable" },
                {
                  name: "รายจ่ายเพื่อการออม/ลงทุน",
                  value: "sum_expenses_invest_saving",
                },
              ]?.map((itemA, index) => (
                <tr key={index}>
                  <td className=" font-medium text-[8px] p-0 text-[#18488A]">
                    <div className=" w-full h-full p-[1px] pl-[10px] border-l-0 border-t-0 border-[0.5px]">
                      {itemA.name}
                    </div>
                  </td>
                  {allData?.map((item, idx) => (
                    <td
                      key={idx}
                      className=" font-normal text-[7px] p-0 text-[#18488A] text-center"
                    >
                      <div
                        className={cn(
                          " w-full h-full p-[1px] pl-[5px] border-r-[0.5px] border-b-[0.5px]"
                          // { "border-r-0": idx === 3 }
                        )}
                      >
                        {item?.balanceData?.[itemA.value]
                          ? itemA.value !== "sum_expenses_invest_saving"
                            ? numeral(item?.balanceData[itemA.value]).format(
                                "0,0"
                              )
                            : numeral(
                                netCashFlow(item?.balanceData) +
                                  SumSaving(
                                    addExpensesInvest(item?.balanceData)
                                  ) <
                                  0
                                  ? 0
                                  : netCashFlow(item?.balanceData) +
                                      SumSaving(
                                        addExpensesInvest(item?.balanceData)
                                      )
                              ).format("0,0")
                          : "-"}
                        {/* {item?.balanceData?.[itemA.value] &&
                        itemA.value === "sum_expenses_invest_saving"
                          ? numeral(
                              netCashFlow() + SumSaving(addExpensesInvest) < 0
                                ? 0
                                : netCashFlow + SumSaving(addExpensesInvest)
                            ).format("0,0")
                          : "-"} */}
                      </div>
                    </td>
                  ))}
                </tr>
              ))}

              {/* กระแสเงินสดสุทธิ */}
              <tr className="h-fit w-fit">
                <td className=" text-[8px] p-0 text-[#00A9A0] font-medium">
                  <div className=" w-full h-full p-[1px] pl-[5px] border-l-0 border-t-0 border-[0.5px]">
                    กระแสเงินสดสุทธิ
                  </div>
                </td>
                {allData?.map((item, index) => (
                  <td
                    key={index}
                    className=" font-normal text-[7px] p-0 text-[#18488A] text-center"
                  >
                    <div
                      className={cn(
                        " w-full h-full p-[1px] pl-[5px] border-r-[0.5px] border-b-[0.5px]"
                        // { "border-r-0": index === 3 }
                      )}
                    >
                      {Number(
                        item?.balanceData?.sum_salary_peryear || 0
                      ) +
                      Number(
                        item?.balanceData?.sum_interest_peryear || 0
                      ) +
                      Number(item?.balanceData?.sum_other_income || 0) -
                      (Number(
                        item?.balanceData?.sum_expenses_fixed || 0
                      ) +
                        Number(
                          item?.balanceData?.sum_expenses_variable || 0
                        ) +
                        Number(
                          item?.balanceData?.sum_property_invest || 0
                        ))
                        ? numeral(
                            Number(
                              item?.balanceData?.sum_salary_peryear || 0
                            ) +
                              Number(
                                item?.balanceData?.sum_interest_peryear ||
                                  0
                              ) +
                              Number(
                                item?.balanceData?.sum_other_income || 0
                              ) -
                              (Number(
                                item?.balanceData?.sum_expenses_fixed || 0
                              ) +
                                Number(
                                  item?.balanceData
                                    ?.sum_expenses_variable || 0
                                ) +
                                Number(
                                  item?.balanceData
                                    ?.sum_property_invest || 0
                                ))
                          ).format("0,0")
                        : "-"}
                    </div>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>

        {/* Charts */}
        <div className="flex flex-row w-full justify-center pb-[30px] ">
          {/* Bar Chart */}
          <div className="bg-white pl-3 w-fit">
            <div className="mb-2 text-[8px] ">หน่วย : บาท</div>
            <div className="w-[242px] h-[150px]">
              <Bar data={barChartData} options={barChartOptions} />
            </div>
            <div className="flex flex-row w-full mt-[10px] space-x-[13px] pl-[20px]">
              <div className="w-fit h-fit flex flex-row ">
                <div className="!w-[21px] !h-[8px] bg-[#18488A]"></div>
                <div className="pl-1 text-[6px]">กระแสเงินสดสุทธิ</div>
              </div>
              <div className="w-fit h-fit flex flex-row ">
                <div className="!w-[21px] !h-[8px] bg-[#A9B4CC]"></div>
                <div className="pl-1 text-[6px]">กระแสเงินสดสุทธิ</div>
              </div>
              <div className="w-fit h-fit flex flex-row ">
                <div className="!w-[21px] !h-[8px] bg-[#B5D4FF]"></div>
                <div className="pl-1 text-[6px]">รายรับรวม</div>
              </div>
            </div>
          </div>

          {/* Line Chart */}
          {/* <div className="bg-white pl-3 w-full ">
            <div className="mb-2 text-[8px] ">หน่วย : บาท</div>
            <div className="w-[242px] h-[150px]">
              <Line data={lineChartData} options={lineChartOptions} />
            </div>
            <div className="flex flex-row w-full mt-[10px] space-x-[13px] pl-[20px]">
              <div className="w-fit h-fit flex flex-row ">
                <div className="!w-[21px] !h-[8px] bg-[#18488A]"></div>
                <div className="pl-1 text-[6px]">กระแสเงินสดสุทธิ</div>
              </div>
              <div className="w-fit h-fit flex flex-row ">
                <div className="!w-[21px] !h-[8px] bg-[#A9B4CC]"></div>
                <div className="pl-1 text-[6px]">กระแสเงินสดสุทธิ</div>
              </div>
              <div className="w-fit h-fit flex flex-row ">
                <div className="!w-[21px] !h-[8px] bg-[#B5D4FF]"></div>
                <div className="pl-1 text-[6px]">รายรับรวม</div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default AnalysisTableOne;
